<app-back-to-integrations-button></app-back-to-integrations-button>
<div class="page-content">
	<div>
		<img src="/assets/images/integrations/title-plus-logo.svg" />
	</div>
	<div>
		<div class="flex justify-between">
			<h2>TitlePLUS</h2>
			<ng-container *ngIf="user$ | async as user">
				<app-button
					*ngIf="user.admin"
					btn="secondary"
					(click)="manageLSNs()"
					size="small"
					class="mt-2"
					[testHook]="testHooks.ManageLsnsButton"
					>Manage LSNs</app-button
				>
			</ng-container>
		</div>
		<p class="mt-5">
			Order title insurance from this industry leading provider without leaving
			Closer.
		</p>
		<ng-container *ngIf="lawyers$ | async as lawyers">
			<app-container *ngIf="lawyers.length; else noneConnected">
				<table mat-table [dataSource]="lawyers" class="w-full">
					<!-- initials -->
					<ng-container matColumnDef="initials">
						<th mat-header-cell *matHeaderCellDef>Name</th>
						<td mat-cell *matCellDef="let element">
							<atomic-name-badge
								[name]="element.name"
								size="small"
							></atomic-name-badge>
						</td>
					</ng-container>

					<!-- name -->
					<ng-container matColumnDef="name">
						<th mat-header-cell *matHeaderCellDef></th>
						<td mat-cell *matCellDef="let element">
							{{ element.name }}
						</td>
					</ng-container>

					<!-- lsn -->
					<ng-container matColumnDef="lsn">
						<th mat-header-cell *matHeaderCellDef>LSN</th>
						<td mat-cell *matCellDef="let element">
							<p class="text-grey-light" *ngIf="!element.lsn">Unavailable</p>
							<p *ngIf="element.lsn">{{ element.lsn }}</p>
						</td>
					</ng-container>

					<!-- status -->
					<ng-container matColumnDef="status">
						<th mat-header-cell *matHeaderCellDef>Status</th>
						<td mat-cell *matCellDef="let element">
							<p class="text-grey" *ngIf="element.connected">
								<app-icon
									[icon]="ICON.LIGHTNING_BOLT"
									class="mr-4 text-green"
								></app-icon
								>Connected
							</p>
							<p class="text-grey" *ngIf="!element.connected">
								<app-icon [icon]="ICON.PLUG" class="mr-4"></app-icon>Not
								Connected
							</p>
						</td>
					</ng-container>

					<!-- action -->
					<ng-container matColumnDef="action">
						<th mat-header-cell *matHeaderCellDef></th>
						<td mat-cell *matCellDef="let element">
							<a
								*ngIf="element.lsn"
								[externalNavInterceptor]="{ useLeapNativeBrowser: true }"
								[href]="link + element.id + '&scope=openid%20offline_access'"
								target="_blank"
								[testHook]="testHooks.ConnectReconnectBtnLink"
							>
								<app-button
									btn="secondary"
									class="mr-5"
									size="small"
									*ngIf="element.connected"
									[testHook]="testHooks.LinkReconnectButton"
									><span class="w-24">Reconnect</span></app-button
								>
								<app-button
									btn="primary"
									class="mr-5"
									size="small"
									*ngIf="!element.connected"
									[testHook]="testHooks.LinkConnectButton"
									><span class="w-24">Connect</span></app-button
								>
							</a>
							<app-button
								*ngIf="!element.lsn"
								btn="secondary"
								(click)="manageLSNs(element.id)"
								size="small"
								class="mt-2 w-5"
								[testHook]="testHooks.AddLsnButton"
								>Add LSN</app-button
							>
						</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
					<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
				</table>
			</app-container>
		</ng-container>

		<ng-template #noneConnected>
			<app-button
				(click)="connect()"
				size="small"
				[testHook]="testHooks.ConnectButton"
				>Connect</app-button
			>
		</ng-template>
	</div>
	<div>
		<app-container title="Resources" type="dark">
			<div class="text-sm flex flex-col gap-2">
				<a
					class="flex gap-2"
					externalNavInterceptor
					href="https://mytitleplus.ca/"
					target="_blank"
					title="Home & toots"
					[testHook]="testHooks.ProfileLink"
				>
					<app-icon [icon]="ICON.PERSON"></app-icon>
					<div class="flex flex-col">
						<span class="font-bold">My profile</span>
						<span class="text-gray-400">View my TitlePLUS profile.</span>
					</div>
				</a>
				<a
					class="border-t-2 border-grey-lighter pt-4 m-2 flex flex-col items-center"
					externalNavInterceptor
					href="https://titleplus.ca/"
					target="_blank"
					title="Enroll now"
					[testHook]="testHooks.EnrollNowLink"
				>
					<p>New to TitlePLUS?</p>
					<app-button
						[icon]="ICON.EXTERNAL"
						size="small"
						[testHook]="testHooks.EnrollNowButton"
						>Enroll now</app-button
					>
				</a>
			</div>
		</app-container>
		<div
			class="rounded-md border border-grey-lighter w-64 max-w-fit mt-8 bg-white"
		>
			<div class="flex justify-between items-center m-5">
				<p class="text-2xl font-bold">Contact info</p>
			</div>
			<hr class="w-full my-4 text-grey-lighter" />
			<div class="flex gap-2 px-5 mb-2">
				<app-icon class="text-green" [icon]="ICON.BUILDING"></app-icon>
				<p class="font-bold">TitlePLUS</p>
			</div>
			<div class="text-sm px-5 flex flex-col gap-2 mb-4">
				<div class="flex gap-2">
					<app-icon class="text-grey-lighter" [icon]="ICON.LOCATION"></app-icon>
					<p>250 Yonge Street, Suite 3101, P.O. Box 3, Toronto, ON</p>
				</div>
				<div class="flex gap-2">
					<app-icon class="text-grey-lighter" [icon]="ICON.PHONE"></app-icon>
					<p>(800) 410-1013</p>
				</div>
				<div class="flex gap-2">
					<app-icon class="text-grey-lighter" [icon]="ICON.FAX"></app-icon>
					<p>(800) 286-7639</p>
				</div>
			</div>
		</div>
	</div>
</div>
